import { isNil } from 'ramda';

export class RatedCapacity {
  public readonly value: number | null;

  constructor(value: number | null) {
    this.value = value;
  }

  static calculate(
    availableCapacity?: number | null,
    loadingPercent?: number | null
  ): RatedCapacity {
    if (isNil(availableCapacity) || isNil(loadingPercent))
      return new RatedCapacity(null);

    const value = (availableCapacity * 100.0) / (100.0 - loadingPercent);
    return new RatedCapacity(value);
  }
}
